export function setDocTitle(title:string){
  document.title = title + " / Huntly";
}